<template>
  <div v-bind="$attrs">
    <div
      class="radio-group"
      :style="`grid-template-columns: repeat(${customCols}, auto); grid-gap: ${gap}`"
    >
      <div v-for="option in options">
        <label class="app-radio" :for="inputId(option)">
          <input
            :id="inputId(option)"
            type="radio"
            :checked="getOptionValue(option) === value"
            :name="name"
            :disabled="disabled || option.disabled"
            @change="update(option)" />
          <span></span>
          <div v-if="renderLabel" v-html="renderLabel(option)"></div>
          <div v-else>{{ option[labelKey || 'text'] }}</div>
        </label>
      </div>
    </div>

    <small class="text-danger" v-if="error">
      {{ error }}
    </small>
    <span class="help-block" v-if="help">{{ help }}</span>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'options',
    'name',
    'error',
    'help',
    'cols',
    'gap',
    'disabled',
    'mediaQuery',
    'renderLabel',
    'labelKey',
    'valueKey'
  ],
  data() {
    return {
      customCols: this.$props?.cols,
    }
  },
  mounted() {
    if (this.$props.mediaQuery?.length) {
      this.mediaQueryListen()
      this.mediaQueryCalculate()
    }
  },
  unmounted() {
    if (this.$props.mediaQuery?.length) {
      this.mediaQueryRemoveListen()
    }
  },
  methods: {
    mediaQueryListen() {
      window.addEventListener('resize', this.mediaQueryCalculate)
    },

    mediaQueryRemoveListen() {
      window.removeEventListener('resize', this.mediaQueryCalculate)
    },

    mediaQueryCalculate() {
      const mediaArray = this.$props.mediaQuery.sort((a, b) => a.media - b.media)
      const self = this
      mediaArray.forEach((screen, index) => {
        if (window.innerWidth > screen.media) {
          self.customCols = screen.cols
        }
      })
    },

    getOptionValue(option) {
      return this.valueKey ? option[this.valueKey] : option.value;
    },

    update(option) {
      this.$emit('input', this.getOptionValue(option));
    },

    inputId(option) {
      // sanitize so it’s a valid id attribute
      const val = String(this.getOptionValue(option)).replace(/\s+/g, '_');
      return `${this.name || 'radio'}_${val}`;
    }
  }
}
</script>

<style scoped lang="scss">
.radio-group {
  display: grid;
  justify-content: flex-start;
  grid-column-gap: 20px;
  width: 100%;
}
</style>